import { FALLBACK_SHIPPING_TYPE, SHIPPING_LINE_TYPE } from "../../../../constants";


export const EXCHANGE_ORDER_SHIPPING_OPTIONS = [
    {
        value: SHIPPING_LINE_TYPE.SELECT_FIRST_FREE_SHIPPING,
        label: 'Use any existing free shipping rate',
        description: 'Automatically pick the first free shipping rate from store settings. If none exist, manual selection required.'
    },
    {
        value: SHIPPING_LINE_TYPE.LEAVE_BLANK,
        label: 'Select shipping rate manually',
        description: 'No shipping rate will be set. Manual selection from available shipping rates when creating the order.'
    },
    {
        value: SHIPPING_LINE_TYPE.CREATE_CUSTOM_FREE_SHIPPING,
        label: 'Create custom free shipping rate',
        description: 'Create a specific free shipping rate for all exchange new orders.'
    },
    {
        value: SHIPPING_LINE_TYPE.SELECT_SPECIFIC_FREE_SHIPPING,
        label: 'Always use one selected shipping rate',
        description: 'Always apply one existing free shipping rate by name to all new orders in exchanges.'
    }
];

export const FALLBACK_EXCHANGE_ORDER_SHIPPING_OPTIONS = [
    {
        value: FALLBACK_SHIPPING_TYPE.LEAVE_BLANK,
        label: 'Manual selection required',
    },
    {
        value: FALLBACK_SHIPPING_TYPE.CREATE_CUSTOM_FREE_SHIPPING,
        label: 'Create it as free custom shipping rate',
    }
];
